module.exports = __webpack_public_path__ + "assets/img/ja-f804030e.png";